// export const API_BASE_URL = "http://localhost:8080";
export const API_BASE_URL = "https://aquageo.kz";
// export const API_BASE_URL = "http://aquageo.kz";
export const CLIENT_BASE_URL = "http://localhost:3000";
// export const CLIENT_BASE_URL = "https://aquageo.kz";
// export const CLIENT_BASE_URL = "http://aquageo.kz";
// export const ANALYZER_API_URL = "http://localhost:8000";
export const ANALYZER_API_URL = "https://aquageo.kz/8000";
